import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/vi/articles")({
  component: () => <Outlet />,
});